/**
 * Permission slugs this plugin declares, in one place so the web affordance
 * gates and the server route postures cannot drift apart.
 *
 * `personas:write` is **not** the gate on writing a persona. Every
 * `/agent-personas` route runs under `personas:read`; the write slug is
 * consulted only by `assertCanWriteOwned`, and only to decide whether the
 * caller may write the *organization-owned* tier. A member without it can
 * still create, edit and delete personas they own, and
 * the create form submits their own user id as the explicit owner.
 *
 * On the client that means: gate the Organization owner option on
 * {@link PERSONA_WRITE}, and gate edit/delete on `useCanWriteOwned`. Gating
 * a create button or a whole form on this slug locks members out of a write
 * the server grants them.
 */
export const PERSONA_READ = 'personas:read';
export const PERSONA_WRITE = 'personas:write';
